// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2741":"724032bde111d079","3414":"bb7684739e065c08","5292":"51f3f619fa9a142d","9651":"7137cc383942b1db"}[chunkId] + ".js";
};